import styled from '@emotion/styled'

import { overrideOptional } from '@emico/overrides'

import Button from './Button'

export default overrideOptional(styled(Button)`
  display: inline;
  background: none;
  padding: 0;
  font: inherit;
  user-select: text;

  /* Source: https://html.spec.whatwg.org/multipage/rendering.html#the-css-user-agent-style-sheet-and-presentational-hints */
  color: #0000ee;
  cursor: pointer;
  text-decoration: underline;

  :focus {
    outline: auto;
  }

  :active {
    color: #ff0000;
  }
`)
